import React, { useState } from "react";
import { Descriptions, Space } from "antd";

import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

import { PageHeader, Button, Popconfirm } from "antd";

import FormUpdateState from "../../../../components/job/status/modal";
import TaskList from "../../../../components/job/task/list/basic";

import { isFinalStatus } from "../../../../components/job/status";

const Details = (props) => {
    const [modalVisible, setModalVisible] = useState(false);
    const showModal = () => setModalVisible(true);
    const hideModal = () => setModalVisible(false);

    const disabled = isFinalStatus(props.record.status);
    const tasks = (props.extra?.tasks || []).filter((item) => (props.record?.tasks || []).indexOf(item?.id) > -1);

    return (
        <>
            <PageHeader
                style={{ margin: 0, padding: 0 }}
                title="Details"
                key="1"
                extra={[
                    <Space size="small" key="0">
                        {!disabled && (
                            <Button type="default" size="small" icon={<EditOutlined />} onClick={showModal}>
                                {props.record.status}
                            </Button>
                        )}
                        {!disabled && (
                            <Popconfirm
                                title="Are you sure?"
                                onConfirm={() => props.onDelete(props.record.id)}
                                okText="Remove"
                                cancelText="No"
                                key="2"
                            >
                                <Button type="dashed" danger icon={<DeleteOutlined />} size="small">
                                    {" "}
                                    Delete
                                </Button>
                            </Popconfirm>
                        )}
                    </Space>,
                ]}
            ></PageHeader>
            <TaskList
                flat
                job={props.record}
                tasks={tasks}
                vendorsById={props.vendorsById}
                unitsById={props.unitsById}
                categoriesById={props.categoriesById}
                languagesById={props.languagesById}
                languagePairsById={props.languagePairsById}
            />
            {!disabled && modalVisible && (
                <FormUpdateState
                    state={props.record.status}
                    updateState={props.onUpdateStatus}
                    onCancel={hideModal}
                    modalVisible={modalVisible}
                />
            )}
        </>
    );
};

export default Details;
